/**
 * Configuration de la grille GridStack : taille des cellules et options communes.
 * Aucun layout par défaut : un dashboard sans config persistée s'affiche VIDE.
 * staticGrid: true verrouille la grille tant que le mode personnalisation est inactif.
 */
import { GridStackOptions } from "gridstack";

const CELL_HEIGHT = 50;

export const BREAKPOINTS = [
  { c: 8, w: 1280 },
  { c: 4, w: 1024 },
  { c: 2, w: 768 },
  { c: 1, w: 576, layout: "list" as const },
];

// Responsive par breakpoints (largeur de FENÊTRE, alignés sur Tailwind md/lg) :
// - téléphone (< 768px) : 1 colonne → widgets empilés, chacun pleine largeur ;
// - tablette (768–1023px) : 2 colonnes ;
// - desktop (≥ 1024px) : DESKTOP_COLUMNS colonnes.
// NB : `breakpoints` remplace l'ancien `columnWidth` fluide (les deux sont exclusifs
// côté GridStack). La correspondance se fait sur `largeur <= w`.
export const COLUMN_OPTS = {
  // moveScale : repositionne/redimensionne proportionnellement au changement de
  // colonnes (un widget demi-largeur en 88 col devient ~1 col sur 2 en tablette ;
  // en 1 colonne, tout passe pleine largeur).
  layout: "moveScale" as const,
  breakpoints: BREAKPOINTS,
  columnMax: 12,
};

const BASE_GRID_OPTIONS = {
  acceptWidgets: true,
  columnOpts: COLUMN_OPTS,
  margin: 3,
  cellHeight: CELL_HEIGHT,
  staticGrid: true,
  // Anime les repositionnements/redimensionnements (déplacement fluide, non "brut").
  animate: true,
  // Placement libre : les widgets restent où on les pose (pas de "gravité" qui
  // les fait remonter pour combler les vides) → on peut laisser des espaces.
  float: true,
  // Lazy load : GridStack ne monte le contenu d'un widget (via renderCB → portail
  // React) que lorsqu'il entre dans le viewport (IntersectionObserver). Évite, sur
  // un grand dashboard, de monter tous les widgets — et tous leurs appels API
  // (ex. météo) — d'un coup au chargement.
  lazyLoad: true,
} satisfies Partial<GridStackOptions>;

/** Construit les options de grille à partir d'un layout (issu de la config persistée). */
export function buildDashboardGridOptions(
  children: GridStackOptions["children"]
): GridStackOptions {
  return { ...BASE_GRID_OPTIONS, children };
}
